import React from 'react';
import HomePage from './components/pages/HomePage';

function App() {
  return (
    <HomePage />
  );
}

export default App;
